<template lang="pug">
.main-box
  .principal-chart
    .arrow.arrow-fee
      .curve
      .point
    .arrow.arrow-miner
      .curve
      .point
    .arrow.arrow-referred(v-if="showDetail")
      .curve
      .point
    span.description.description-fee Platform's fee
    span.description.description-miner {{ minerText }}
    span.description.description-referred(
      :style="'left: calc(50% - ' + referredTextPosition + 'px);'",
      v-if="showDetail"
      ) {{ referredText }}
    .fee(:style="'width: ' + (showDetail ? widthDetailFee : widthPrincipalFee) + '%;'")
      span.percentage.percentage-very-small(v-if="showDetail") 
        span {{ tier.platform_percentage }}%
      span.percentage.percentage-very-small(v-else)
        span(v-if="withRefCode") 0.75%
        span(v-else) 1%
    .referred(:style="'width: ' + widthDetailReferred + '%;' + (showDetail ? 'z-index:9;' : 'min-width:40px;')", v-if="showDetail")
      span.percentage.percentage-small {{ tier.owner_percentage }}%
    .miner-bar(:style="'width: ' + widthPrincipalMiner + '%;'", :class="{'detailed-view': showDetail}")
      span.percentage(v-if="withRefCode || showDetail") 99.25%
      span.percentage(v-else) 99%


</template>

<script>
export default {
  name: 'c_referral_image',
  props: ['showDetail', 'tier', 'type', 'widthFee', 'widthMiner', 'withRefCode'],
  data() {
    return {
      widthPrincipalFee: 17,
      widthPrincipalMiner: 83,
      widthDetailFee: 50,
      widthDetailReferred: 25,
      widthDetailMiner: 25,
      minerText: 'Your rewards',
      referredText: 'Your extra rewards',
      referredTextPosition: 88
    }
  },
  watch: {
    tier: function () {
      var vm = this
      if (vm.tier) {
        switch (vm.tier.code) {
          case 0:
            vm.widthDetailFee = 13;
            vm.widthDetailReferred = 12;
            break;
          case 1:
            vm.widthDetailFee = 12;
            vm.widthDetailReferred = 13;
            break;
          case 2:
            vm.widthDetailFee = 11;
            vm.widthDetailReferred = 14;
            break;
          case 3:
            vm.widthDetailFee = 10;
            vm.widthDetailReferred = 15;
            break;
        }
      }
    },
    widthFee: function () {
      var vm = this
      if (vm.widthFee) vm.widthPrincipalFee = +vm.widthFee;
      else vm.widthPrincipalFee = 17;
    },
    widthMiner: function () {
      var vm = this
      if (vm.widthMiner) vm.widthPrincipalMiner = +vm.widthMiner;
      else vm.widthPrincipalMiner = 83;
    }
  },
  mounted() {
    let vm = this

    if (vm.showDetail) {
      vm.minerText = 'His rewards'
    }

    if (vm.showDetail && vm.tier && vm.tier.name) {
      switch (vm.tier.code) {
        case 0:
          vm.widthDetailFee = 13;
          vm.widthDetailReferred = 12;
          break;
        case 1:
          vm.widthDetailFee = 12;
          vm.widthDetailReferred = 13;
          break;
        case 2:
          vm.widthDetailFee = 11;
          vm.widthDetailReferred = 14;
          break;
        case 3:
          vm.widthDetailFee = 10;
          vm.widthDetailReferred = 15;
          break;
      }
    }

    if (vm.widthFee && vm.widthMiner) {
      vm.widthPrincipalFee = +vm.widthFee
      vm.widthPrincipalMiner = +vm.widthMiner
    }

    if (window.innerWidth < 420) {
      vm.referredTextPosition = 84
    } else {
      vm.referredTextPosition = 88
    }
  }
}
</script>

<style lang="stylus" scoped>

transform-rotate(n)
  transform rotate(n)
  -webkit-transform rotate(n)
  -moz-transform rotate(n)
  -ms-transform rotate(n)
  
.main-box
  position relative
  margin-top 30px
  margin-bottom 30px
.principal-chart
  // border 2px #000 solid
  height 35px
  display flex
  .fee
    transition width 1s ease
    display flex
    align-items center
    justify-content center
    // background-color #64ACD3
    background-color #e4e4e4
    // border-right 2px #000 solid
    border-top-left-radius: 3px
    border-bottom-left-radius: 3px
    z-index 10
  .referred
    transition width 1s ease
    display flex
    align-items center
    justify-content center
    background-color #66E093
    // border-right 2px #000 solid
    z-index 10
  .miner-bar
    transition width 1s ease
    display flex
    align-items center
    justify-content center
    font-size 17px
    background-color #66E093
    border-top-right-radius: 3px
    border-bottom-right-radius: 3px
    z-index 10
    &.detailed-view
      // background-color #209cee
      background-color #5bbeff
  .percentage
    font-size 14px
    color #000
    font-weight 400
    &.percentage-small
      font-size 12px
    &.percentage-very-small
      font-size 10px
  .description
    position absolute
    font-size 11px
    color #000
    font-weight 400
  .description-fee
    top -20px
    left 40px
  .description-referred
    bottom -20px
    left calc( 50% - 90px)
    font-weight: 700;
  .description-miner
    top -20px
    right 40px

.principal-chart.zoom-out
  height 17px
  .percentage
    font-size 11px
    

.detail-chart
  display flex
  justify-content center
  align-items center
  height 120px
  
  .percentage
    font-size 17px
    color #000
    font-weight 400
  .description
    position absolute
    font-size 11px
    color #000
    font-weight 400
  .description-fee
    top -20px
    left 40px
  .description-referred
    bottom -20px
    left calc( 50% - 90px)
    font-weight: 700;
  .description-miner
    top -20px
    right 40px
  .bar
    border 2px #000 solid
    height 35px
    display flex
    width 100%
    position relative
    .fee
      transition width 1s ease
      display flex
      align-items center
      justify-content center
      background-color #64ACD3
      border-right 2px #000 solid
    .referred
      transition width 1s ease
      display flex
      align-items center
      justify-content center
      background-color #F3DA5F
      border-right 2px #000 solid
    .miner-bar
      transition width 1s ease
      display flex
      align-items center
      justify-content center
      font-size 17px
      background-color #66E093
    

.arrow
  position: absolute;
  .curve
    border: 2px solid #000;
    height: 15px;
    width: 18px;
  .point
    position: absolute;
    &::before, 
    &::after
      border: 1px solid #5b5b5b;
      height: 7px;
      content: "";
      position: absolute;
    &::before
      border-radius 1px
    &::after
      border-radius 1px
    
.arrow-fee
  top -13px
  left 18px
  .curve
    border-color: #5b5b5b transparent transparent #5b5b5b;
  .point 
    left: 19px
    top: -15px
    &::before
      top: 14.8px;
      left: -4px;
      transform-rotate(45deg)
    &::after
      top: 10.5px;
      left: -4px;
      transform-rotate(-45deg)

.arrow-miner
  top -13px
  right 18px
  .curve
    border-color: #5b5b5b #5b5b5b transparent transparent;
  .point 
    right: 19px
    top: -15px
    &::before
      top: 14.8px;
      right: -4px;
      transform-rotate(135deg)
    &::after
      top: 10.5px;
      right: -4px;
      transform-rotate(-135deg)

.arrow-referred
  bottom -13px
  left: 18%;
  .curve
    height: 14px
    border-color: transparent transparent #5b5b5b #5b5b5b;
  .point 
    left: 19px
    top: -3px
    &::before
      top: 14.8px;
      left: -4px;
      transform-rotate(45deg)
    &::after
      top: 10.5px;
      left: -4px;
      transform-rotate(-45deg)
    
html.dark, body.dark
  .description
    color: #fff
  .arrow-referred
    .curve
      border-color: transparent transparent #fff #fff;
    .point
      &::before
        border-color #fff
      &::after
        border-color #fff
  .arrow-miner
    .curve
      border-color: #fff #fff transparent transparent;
    .point
      &::before
        border-color #fff
      &::after
        border-color #fff
  .arrow-fee
    .curve
      border-color: #fff transparent transparent #fff;
    .point
      &::before
        border-color #fff
      &::after
        border-color #fff
</style>




// WEBPACK FOOTER //
// c_referral_image.vue?2f4db624